import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '../environments/environment';
import { ClientAppConfig } from './app-config.model';
import { Area } from './core/constants/area';
@Injectable()
export class ConfigService {
    public appConfig: ClientAppConfig = null;

  constructor(
    private http: HttpClient,
  ) { }

  async getAppConfig() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/clientAppConfig`;
    this.appConfig = await this.http.get<ClientAppConfig>(url).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/config.service.ts